import {createSlice, PayloadAction} from '@reduxjs/toolkit';
import {ProfileMenuId} from './constants';
import {ProfileMenuState} from './ProfileMenuState.interface';

export const profileMenuSlice = createSlice({
  name: 'profileMenu',
  initialState: {
    updatedMenus: {
      [ProfileMenuId.Alarm]: false,
      [ProfileMenuId.Notice]: false,
    },
  } as ProfileMenuState,
  reducers: {
    setIsUpdated: (
      state,
      action: PayloadAction<{menuId: ProfileMenuId; isUpdated: boolean}>
    ): void => {
      const {menuId, isUpdated} = action.payload;
      state.updatedMenus[menuId] = isUpdated;
    },
  },
});

export const {setIsUpdated} = profileMenuSlice.actions;
